import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react'

export type SortOrder = 'asc' | 'desc'

type TableSortIconProps = {
	/** The column this icon sits in. */
	columnId: string
	/** The column the table is currently sorted by, or null when unsorted. */
	orderBy: string | null
	/** Current direction of that sort. */
	order: SortOrder
}

/**
 * Sort affordance for a sortable table header.
 *
 * Inactive columns show a muted double arrow so the header reads as sortable
 * before it is clicked; the active column shows the direction in brand blue.
 *
 * Extracted from `screens/taskscn/TasksCN_Index.tsx` when the Home page tasks
 * card gained sorting, so the two do not drift apart.
 */
export function TableSortIcon({ columnId, orderBy, order }: TableSortIconProps) {
	// `shrink-0` matters: as a flex child in a narrow header cell the SVG
	// otherwise collapses to zero width and the affordance silently disappears.
	const cls = 'ml-1 h-3 w-3 shrink-0'
	if (orderBy !== columnId) return <ArrowUpDown className={`${cls} text-gray-300`} />
	return order === 'asc' ? (
		<ArrowUp className={`${cls} text-[#0080fe]`} />
	) : (
		<ArrowDown className={`${cls} text-[#0080fe]`} />
	)
}

export default TableSortIcon
